import WizardBreadcrumbs from './WizardBreadcrumbs';

export default WizardBreadcrumbs;
